import {
  ReadinessSoftSkillRequirement,
  ReadinessHardSkillRequirement,
  ReadinessEdRequirement,
  ReadinessGapLevel
} from 'apps/pathways/components/readiness-breakpoints';

const ReadinessDescriber = (category, readinessObject) => {
  return `${OccupationDescription(category, readinessObject['requirement'])} ${UserDescription(category, readinessObject['score'])}`
}

const UserDescription = (category, score) => {
  const intScore = parseInt(score);
  const gapLevel = ReadinessGapLevel(intScore);

  switch(category) {
    case 'education':
      return UserEdCopy(gapLevel)
    case 'hard skills':
      return UserHSCopy(gapLevel)
    case 'soft skills':
      return UserSSCopy(gapLevel)
  }
}

const OccupationDescription = (category, requirement) => {
  if(category.match(/ed/)) {
    return EdCopy(ReadinessEdRequirement(requirement))
  } else {
    const intReq = parseInt(requirement)
    if(category.match(/hard/)) {
      return HSCopy(ReadinessHardSkillRequirement(intReq))
    } else {
      return SSCopy(ReadinessSoftSkillRequirement(intReq))
    }
  }
}

// ***COPY SECTION***

// USER COPY SESCTION
const UserEdCopy = (gapLevel) => {
  switch(gapLevel) {
    case 1:
      return 'Based on the information you provided, you don\'t need to more Education.'
    case 2:
      return 'Based on the information you provided, you should receive some more Education.'
    case 3:
      return 'Based on the information you provided, you need more Education.'
  }
}

const UserHSCopy = (gapLevel) => {
  switch(gapLevel) {
    case 1:
    return 'Based on the information you provided, you don\'t need to develop your Hard Skills.'
    case 2:
      return 'Based on the information you provided, you should develop some additional Hard Skills.'
    case 3:
      return 'Based on the information you provided, you need to develop your Hard Skills.'
  }
}

const UserSSCopy = (gapLevel) => {
  switch(gapLevel) {
    case 1:
      return 'Based on the information you provided, you don\'t need to develop your Soft Skills.'
    case 2:
      return 'Based on the information you provided, you should develop some additional Soft Skills.'
    case 3:
      return 'Based on the information you provided, you need to develop your Soft Skills.'
  }
}

// OCCUPATION COPY SECTION
const EdCopy = (requirementLevel) => {
  switch(requirementLevel) {
    case 'necessary':
      return 'Education is NECESSARY for your selected career. Making sure you have the required Education is essential to getting a job.'
    case 'important':
      return 'Education is IMPORTANT for your selected career. Making sure you have the required Education is a large role in getting a job.'
    case 'helpful':
      return 'Education is HELPFUL for your selected career, but not as important as other factors for getting a job.'
    default:
      return ''
  }
}

const SSCopy = (requirementLevel) => {
  switch(requirementLevel) {
    case 'necessary':
      return 'Soft Skills are NECESSARY for your selected career. Making sure you have the required Soft Skills is essential to getting a job.'
    case 'important':
      return 'Soft Skills are IMPORTANT for your selected career. Making sure you have the required Soft Skills play a large role in getting a job.'
    case 'helpful':
      return 'Soft Skills are HELPFUL for your selected career, but not as important as other factors for getting a job.'
    default:
      return ''
  }
}

const HSCopy = (requirementLevel) => {
  switch(requirementLevel) {
    case 'necessary':
      return 'Hard Skills are NECESSARY for your selected career. Making sure you have the required Hard Skills is essential to getting a job.'
    case 'important':
      return 'Hard Skills are IMPORTANT for your selected career. Making sure you have the required Hard Skills play a large role in getting a job.'
    case 'helpful':
      return 'Hard Skills are HELPFUL for your selected career, but not as important as other factors for getting a job.'
    default:
      return ''
  }
}

export default ReadinessDescriber
